module.exports = __webpack_public_path__ + "img/fatherhood_7.13a2b1ce.jpg";